'use client';

import { useId, useState } from 'react';
import { ChevronDown } from 'lucide-react';

import { sanitize } from "@/lib/sanitize";
import "./store-v5.css";

interface FaqItem {
  question: string;
  answer: string;
}

interface FaqAccordionProps {
  faqs: FaqItem[];
}

export function FaqAccordion({ faqs }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const baseId = useId();

  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  if (!faqs || faqs.length === 0) return null;

  return (
    <div className="sp-faq-list">
      {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        const sanitizedAnswer = sanitize(faq.answer);
        const panelId = `${baseId}-panel-${index}`;
        return (
          <div key={index} className="sp-faq-item">
            <h3 className="m-0">
              <button
                type="button"
                onClick={() => toggleItem(index)}
                className="sp-faq-button"
                aria-expanded={isOpen}
                aria-controls={panelId}
              >
                <span>{faq.question}</span>
                <ChevronDown aria-hidden="true" />
              </button>
            </h3>

            {/* SEO SAFE: the answer is always in the DOM; when closed it is clipped and inert (not focusable). */}
            <div id={panelId} role="region" className="sp-faq-panel" data-open={isOpen} inert={!isOpen}>
              <div>
                <div className="sp-faq-answer" dangerouslySetInnerHTML={{ __html: sanitizedAnswer }} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
